/* ==========================================================================
   Craft Quest — shared JS (Shopify Horizon)
   - AJAX add to cart (no reload) → re-renders CQ cart drawer + header count
     via Section Rendering API, opens the drawer. Falls back to Horizon's
     cart:update event / toast when the CQ drawer isn't installed.
   - Cart drawer quantity / remove
   - Wishlist heart (localStorage) + header wishlist count
   - Tabs, carousel, "You may also like" loader, Iconify loader
   Guarded: runs once even if many sections include the script.
   ========================================================================== */
(function () {
  if (window.__cqInit) return;
  window.__cqInit = true;

  /* ---------- Iconify ---------- */
  if (!window.customElements || !customElements.get('iconify-icon')) {
    var ic = document.createElement('script');
    ic.src = 'https://code.iconify.design/iconify-icon/2.1.0/iconify-icon.min.js';
    ic.async = true;
    document.head.appendChild(ic);
  }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CQ = window.CQ = window.CQ || {};

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  CQ.toast = function (html, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cq-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('cq-toast--error', !!isError);
    toastEl.innerHTML = html;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3200);
  };

  /* ---------- Body scroll lock (shared by drawers/modals) ---------- */
  var lockCount = 0;
  CQ.lockScroll = function (on) {
    lockCount = Math.max(0, lockCount + (on ? 1 : -1));
    document.documentElement.classList.toggle('cq-locked', lockCount > 0);
  };

  /* ---------- Offcanvas helpers (cart drawer lives here; menu/search in cq-header.js) ---------- */
  function openOffcanvas(el) {
    if (!el || el.classList.contains('is-open')) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    CQ.lockScroll(true);
    el.__lastFocus = document.activeElement;
    var f = el.querySelector('.cq-offcanvas__close, button, a, input');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeOffcanvas(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    CQ.lockScroll(false);
    if (el.__lastFocus && el.__lastFocus.focus) el.__lastFocus.focus();
  }
  CQ.openOffcanvas = openOffcanvas;
  CQ.closeOffcanvas = closeOffcanvas;

  function cartDrawer() { return document.querySelector('[data-cq-cart-drawer]'); }
  CQ.openCart = function () { var d = cartDrawer(); if (d) openOffcanvas(d); return !!d; };
  CQ.closeCart = function () { closeOffcanvas(cartDrawer()); };

  /* ---------- Section ids to re-render after cart changes ---------- */
  function cqSectionIds() {
    var ids = [];
    document.querySelectorAll('[data-cq-section]').forEach(function (el) {
      var id = el.getAttribute('data-cq-section');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    // Also include Horizon cart bits if present (drawer / icon), so its own UI stays in sync
    ['cart-drawer-component', 'cart-items-component', 'cart-icon'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        var id = (el.dataset && el.dataset.sectionId) || null;
        if (!id) { var w = el.closest('.shopify-section'); id = w ? w.id.replace('shopify-section-', '') : null; }
        if (id && ids.indexOf(id) === -1) ids.push(id);
      });
    });
    return ids;
  }

  function setCounts(n) {
    document.querySelectorAll('[data-cq-cart-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('is-empty', n === 0); });
    document.querySelectorAll('.cart-bubble__text, [data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  /* Apply rendered sections HTML to the page.
     Exposed as CQ.syncCart so the product page can call it directly instead of
     going through the cart:update event (which ignores CQ's own events). */
  function applySections(sections) {
    if (!sections) return null;
    var count = null;
    var parser = new DOMParser();
    Object.keys(sections).forEach(function (id) {
      if (!sections[id]) return;
      var doc = parser.parseFromString(sections[id], 'text/html');

      // CQ cart drawer content
      var newRender = doc.querySelector('[data-cq-cart-render]');
      var oldRender = document.querySelector('[data-cq-cart-drawer][data-cq-section="' + id + '"] [data-cq-cart-render]');
      if (newRender && oldRender) {
        oldRender.replaceWith(newRender);
        count = parseInt(newRender.getAttribute('data-cq-cart-count-value'), 10);
      }

      // Horizon drawer / icon: replace inner markup of matching components
      ['cart-drawer-component', 'cart-items-component', 'cart-icon'].forEach(function (sel) {
        var n = doc.querySelector(sel), o = document.querySelector(sel);
        if (n && o && o.closest('.shopify-section') && o.closest('.shopify-section').id === 'shopify-section-' + id) {
          try { o.innerHTML = n.innerHTML; } catch (e) { /* ignore */ }
        }
      });
    });
    if (count !== null && !isNaN(count)) setCounts(count);
    return count;
  }

  // Public: re-render cart UI + header counts from a /cart/*.js "sections" payload
  CQ.syncCart = function (sections, fallbackCount) {
    var count = applySections(sections);
    if (count === null || isNaN(count)) {
      if (typeof fallbackCount === 'number') { setCounts(fallbackCount); return Promise.resolve(fallbackCount); }
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { setCounts(cart.item_count); return cart.item_count; })
        .catch(function () { return null; });
    }
    return Promise.resolve(count);
  };
  CQ.setCartCount = setCounts;
  CQ.cartSectionIds = cqSectionIds;

  function cartRequest(path, body) {
    var ids = cqSectionIds();
    if (ids.length) body.sections = ids.join(',');
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || 'Something went wrong');
        return res.json;
      });
  }

  function notifyHorizon(meta, sections, itemCount) {
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: {}, sourceId: 'cq-' + (meta.variantId || 'cart'), data: { source: 'product-form-component', itemCount: itemCount, productId: meta.productId, variantId: meta.variantId, sections: sections || {}, didError: false } }
      }));
    } catch (e) { /* ignore */ }
  }

  /* ---------- Add to cart ---------- */
  function addToCart(btn) {
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.classList.contains('is-loading') || btn.disabled) return;
    var label = btn.querySelector('[data-cq-atc-label]');
    var original = label ? label.textContent : '';
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding…';

    cartRequest('cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] })
      .then(function (json) {
        var count = applySections(json.sections);
        var meta = { variantId: variantId, productId: btn.dataset.productId };
        if (count === null) {
          // CQ drawer not installed → fetch count, notify Horizon
          return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
            setCounts(cart.item_count);
            notifyHorizon(meta, json.sections, cart.item_count);
            var hd = document.querySelector('cart-drawer-component');
            if (hd && typeof hd.open === 'function') { try { hd.open(); return; } catch (e) { /* ignore */ } }
            CQ.toast('<span>Added to cart:</span> <strong>' + (btn.dataset.productTitle || '') + '</strong> <a href="' + root + 'cart">View cart</a>');
          });
        }
        notifyHorizon(meta, json.sections, count);
        CQ.openCart();
      })
      .then(function () {
        btn.classList.add('is-added');
        if (label) label.textContent = 'Added ✓';
        setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = original; }, 1800);
      })
      .catch(function (err) {
        CQ.toast(err.message || 'Could not add to cart', true);
        if (label) label.textContent = original;
      })
      .finally(function () { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); });
  }

  /* ---------- Cart drawer: change quantity ---------- */
  var qtyTimer;
  function changeLine(line, quantity) {
    var drawer = cartDrawer();
    if (drawer) drawer.classList.add('is-busy');
    cartRequest('cart/change.js', { line: Number(line), quantity: Number(quantity) })
      .then(function (json) {
        var count = applySections(json.sections);
        notifyHorizon({}, json.sections, count === null ? json.item_count : count);
        if (count === null) setCounts(json.item_count);
      })
      .catch(function (err) { CQ.toast(err.message, true); })
      .finally(function () { if (drawer) drawer.classList.remove('is-busy'); });
  }

  /* ---------- Wishlist ----------
     Stored as an array of product HANDLES in localStorage under 'cq_wishlist'.
     Handles (not ids) are stored so the wishlist page can re-fetch each product.
     Legacy numeric entries from earlier versions are dropped on first read. */
  var WISH_KEY = 'cq_wishlist';
  function getWish() {
    var list;
    try { list = JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; }
    if (!Array.isArray(list)) return [];
    var clean = list.filter(function (v) { return typeof v === 'string' && v && !/^\d+$/.test(v); });
    if (clean.length !== list.length) { try { localStorage.setItem(WISH_KEY, JSON.stringify(clean)); } catch (e) { /* ignore */ } }
    return clean;
  }
  function setWish(list) { try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) { /* ignore */ } }
  function paintWish(scope) {
    var list = getWish();
    (scope || document).querySelectorAll('[data-cq-wish]').forEach(function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.dataset.cqWish) !== -1 ? 'true' : 'false');
    });
    document.querySelectorAll('[data-cq-wish-count]').forEach(function (el) { el.textContent = list.length; el.classList.toggle('is-empty', list.length === 0); });
  }
  function toggleWish(btn) {
    var id = btn.dataset.cqWish, list = getWish(), i = list.indexOf(id);
    if (i === -1) list.push(id); else list.splice(i, 1);
    setWish(list);
    paintWish();
    document.dispatchEvent(new CustomEvent('cq:wishlist', { detail: { ids: list, productId: id, added: i === -1 } }));
  }
  CQ.getWishlist = getWish;
  CQ.paintWish = paintWish;
  CQ.removeWish = function (handle) {
    var list = getWish(), i = list.indexOf(handle);
    if (i !== -1) { list.splice(i, 1); setWish(list); paintWish(); document.dispatchEvent(new CustomEvent('cq:wishlist', { detail: { ids: list, productId: handle, added: false } })); }
  };
  CQ.clearWish = function () { setWish([]); paintWish(); document.dispatchEvent(new CustomEvent('cq:wishlist', { detail: { ids: [], added: false } })); };

  /* ---------- Tabs ---------- */
  function activateTab(btn) {
    var wrap = btn.closest('[data-cq-tabs]');
    if (!wrap) return;
    var id = btn.dataset.cqTab;
    wrap.querySelectorAll('[data-cq-tab]').forEach(function (b) { var on = b === btn; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
    wrap.querySelectorAll('[data-cq-panel]').forEach(function (p) { var on = p.dataset.cqPanel === id; p.classList.toggle('is-active', on); if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', ''); });
  }

  /* ---------- Carousel ---------- */
  function carouselStep(track) {
    var slide = track.querySelector('.cq-carousel__slide');
    var gap = parseFloat(getComputedStyle(track).gap) || 0;
    return slide ? slide.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
  }
  function updateArrows(car) {
    var track = car.querySelector('[data-cq-track]'), prev = car.querySelector('[data-cq-prev]'), next = car.querySelector('[data-cq-next]');
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth - 1;
    if (prev) prev.disabled = track.scrollLeft <= 0;
    if (next) next.disabled = track.scrollLeft >= max;
  }
  function initCarousels() {
    document.querySelectorAll('[data-cq-carousel]').forEach(function (car) {
      if (car.__cq) return;
      car.__cq = true;
      var track = car.querySelector('[data-cq-track]');
      if (!track) return;
      track.addEventListener('scroll', function () { updateArrows(car); }, { passive: true });
      window.addEventListener('resize', function () { updateArrows(car); });
      updateArrows(car);
    });
  }

  /* ---------- You may also like (recommendations API) ---------- */
  function initRelated() {
    document.querySelectorAll('[data-cq-related]').forEach(function (el) {
      if (el.__cq || !el.dataset.url) return;
      el.__cq = true;
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('[data-cq-related]');
        if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; paintWish(el); }
        else { var sec = el.closest('.cq-related'); if (sec) sec.hidden = true; }
      }).catch(function () { /* ignore */ });
    });
  }

  /* ---------- Delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var atc = t.closest('[data-cq-add-to-cart]');
    if (atc) { e.preventDefault(); addToCart(atc); return; }

    var wish = t.closest('[data-cq-wish]');
    if (wish) { e.preventDefault(); toggleWish(wish); return; }

    var tab = t.closest('[data-cq-tab]');
    if (tab) { e.preventDefault(); activateTab(tab); return; }

    var prev = t.closest('[data-cq-prev]'), next = t.closest('[data-cq-next]');
    if (prev || next) {
      var car = (prev || next).closest('[data-cq-carousel]');
      var track = car && car.querySelector('[data-cq-track]');
      if (track) track.scrollBy({ left: (prev ? -1 : 1) * carouselStep(track), behavior: 'smooth' });
      return;
    }

    if (t.closest('[data-cq-cart-open]')) { if (CQ.openCart()) e.preventDefault(); return; }
    if (t.closest('[data-cq-cart-close]')) { CQ.closeCart(); return; }

    var minus = t.closest('[data-cq-qty-minus]'), plus = t.closest('[data-cq-qty-plus]');
    if (minus || plus) {
      var input = (minus || plus).closest('[data-cq-qty]').querySelector('[data-cq-qty-input]');
      var q = Math.max(0, (parseInt(input.value, 10) || 0) + (plus ? 1 : -1));
      input.value = q;
      changeLine(input.dataset.line, q);
      return;
    }
    var rm = t.closest('[data-cq-remove]');
    if (rm) { changeLine(rm.dataset.line, 0); }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-cq-qty-input]');
    if (!input) return;
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(function () { changeLine(input.dataset.line, Math.max(0, parseInt(input.value, 10) || 0)); }, 250);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { CQ.closeCart(); }
    var tab = e.target.closest && e.target.closest('[data-cq-tab]');
    if (!tab) return;
    var tabs = Array.prototype.slice.call(tab.closest('[role="tablist"]').querySelectorAll('[data-cq-tab]'));
    var i = tabs.indexOf(tab);
    if (e.key === 'ArrowRight') { e.preventDefault(); var n = tabs[(i + 1) % tabs.length]; n.focus(); activateTab(n); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); var p = tabs[(i - 1 + tabs.length) % tabs.length]; p.focus(); activateTab(p); }
  });

  // Keep drawer/count in sync if Horizon's own product form adds something
  document.addEventListener('cart:update', function (e) {
    var d = e.detail && e.detail.data;
    if (!d || (e.detail.sourceId || '').indexOf('cq-') === 0) return;
    if (d.sections) applySections(d.sections);
    if (typeof d.itemCount === 'number') setCounts(d.itemCount);
  });

  function init() { paintWish(); initCarousels(); initRelated(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cq:rendered', init);
})();
